"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const get_1 = __importDefault(require("lodash/get"));
const Status = __importStar(require("../../utils/Status"));
exports.default = {
    // TODO Type the response
    delete: function (object, socket, socketPrefix, collection, callback = undefined) {
        return new Promise((resolve) => {
            const id = object.attributes.id;
            socket.emit(`${socketPrefix}.delete`, object.attributes.id, (0, get_1.default)(object.attributes, 'data.customCachePath'), (status) => {
                if (Status.isStatusOk(status)) {
                    const { id: deletedId } = Status.unwrap(status);
                    if (deletedId !== undefined) {
                        object.set('id', deletedId);
                        object.setDeleted();
                        if (collection) {
                            collection.removeById(id);
                        }
                    }
                    if (typeof callback === 'function') {
                        callback = callback.bind(object);
                        callback();
                    }
                }
                resolve(status);
            });
        });
    },
    deleteInMemory: function (object, collection) {
        object.setDeleted();
        if (collection) {
            collection.removeById(object.attributes.id);
        }
    },
    saveInMemory: function (object, collection) {
        if (object.isNew()) {
            object.setNew(false);
            if (collection) {
                collection.add(this);
            }
        }
        else {
            if (collection.getIndex(object.attributes.id) >= 0) {
                collection.updateById(object.attributes.id, object);
            }
            else {
                collection.add(object);
            }
        }
    },
    // TODO Type the response
    save: function (object, socket, socketPrefix, collection, callback = undefined) {
        return new Promise((resolve) => {
            if (object.isNew()) {
                object.setNew(false);
                socket.emit(`${socketPrefix}.create`, object.attributes, ((response) => {
                    if (!response.error) {
                        object._wasFrozen = object.attributes.is_frozen === true;
                        if (response.integer_id) {
                            object.set('integer_id', response.integer_id);
                        }
                        if (collection) {
                            collection.add(object);
                        }
                        if (typeof callback === 'function') {
                            callback = callback.bind(object);
                            callback();
                        }
                    }
                    resolve(response);
                }).bind(object));
            }
            else {
                socket.emit(`${socketPrefix}.update`, object.attributes.id, object.attributes, ((response) => {
                    if (!response.error) {
                        object._wasFrozen = object.attributes.is_frozen === true;
                        if (collection) {
                            if (collection.getIndex(object.attributes.id) >= 0) {
                                collection.updateById(object.attributes.id, object);
                            }
                            else {
                                collection.add(object);
                            }
                        }
                    }
                    resolve(response);
                }).bind(object));
            }
        });
    },
    saveAll: function (objects, socket, socketPrefix, collection) {
        return new Promise((resolve) => {
            const attributesList = objects.map((obj) => obj.attributes);
            socket.emit(`${socketPrefix}.updateBatch`, attributesList, (response) => {
                if (!response.error) {
                    objects.forEach((object) => {
                        object._wasFrozen = object.attributes.is_frozen === true;
                        if (collection) {
                            if (collection.getIndex(object.attributes.id) >= 0) {
                                collection.updateById(object.attributes.id, object);
                            }
                            else {
                                collection.add(object);
                            }
                        }
                    });
                }
                resolve(response);
            });
        });
    }
};
//# sourceMappingURL=SaveUtils.js.map